import axios from "axios"
import {useState} from "react"
import {useRoute, Link} from "wouter"
import appConfig from "../service/config"
import getErrorMessage from "../service/getError";
import Spinner from "./Spinner";

const ResetPW = props => {
  const [responseMessage, setResponseMessage] = useState('')
  const [saved, setSaved] = useState(false)
  const [loading, setLoading] = useState(false)
  const [match, params] = useRoute("/dashboard/reset/:token")

  const t = match ? params.token : ''

  const onSubmit = async e => {
    e.preventDefault()
    setLoading(true)
    try {
      await axios.put(appConfig.api_base + 'tipsters/password/reset', {
        "password": e.target.elements.password.value,
        "id": t
      })
      setResponseMessage('')
      setLoading(false)
      setSaved(true)
    } catch (error) {
      window.dispatchEvent(appConfig.showMessage(getErrorMessage(error)));
      setResponseMessage(getErrorMessage(error))
      setLoading(false)
    }
  }

  return (
    <>
      {saved &&
        <div className="alert alert-success alert-dismissible fade show">
          <h2>Register</h2>
          <strong>Password saved.</strong><br />
          <Link href="/dashboard/login">login</Link><br />
        </div>
      }
      {!saved &&
        <form className="mtr-form" onSubmit={onSubmit}>
          <h2>Reset password</h2>
          <div className="mb-3">
            <label htmlFor="password" className="form-label">Password</label>
            <input type="password" className="form-control" id="password" name="password" required/>
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            Submit<Spinner loading={loading}/>
          </button>
          {responseMessage && <div className="text-danger">{responseMessage}</div>}
        </form>
      }
    </>
  )
};

export default ResetPW
